import { Component, ViewChild, enableProdMode } from '@angular/core';
import { Platform, Nav } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import firebase from 'firebase';

import { FirebaseService } from '../providers/firebase-service';

enableProdMode();
@Component({
  templateUrl: 'app.html'
})
export class GoNApp {
  
  @ViewChild(Nav) nav: Nav;

  private NUM_THINGS_TO_LOAD: number = 1;

  private checkReadyToLoadInterval;
  private numThingsLoaded: number;  

  constructor(private platform: Platform, private statusBar: StatusBar, private splashScreen: SplashScreen, private firebaseService: FirebaseService) {
    this.numThingsLoaded = 0;
    platform.ready().then(() => {
      if (this.platform.is("cordova")) {
        statusBar.styleDefault();
        splashScreen.hide();
      }
      this.checkReadyToLoadInterval = setInterval(() => {
        if (this.numThingsLoaded == this.NUM_THINGS_TO_LOAD) {
          clearInterval(this.checkReadyToLoadInterval);
          this.nav.setRoot("HomePage");
        }
      }, 100);
      firebase.auth().signInAnonymously().then(() => { this.numThingsLoaded++; });
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts